import { Box, Typography } from '@mui/material'
import FinanceAiVisual from '../../Landing/FinanceAiVisual'

// Painel promocional do login do minipay — mesma mensagem e visual (chat +
// financeiro + IA) usados na landing (src/content/minipay/Landing), só que
// numa coluna estreita (sidebar de 440px), então headline/visual menores.
export default function MinipayPromo() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
      <img width={170} alt="Youon" src="/static/images/logo/logoyouon.svg" />

      <Box mt={5}>
        <FinanceAiVisual size={260} />
      </Box>

      <Typography
        variant="h3"
        sx={{ mt: 4, mb: 2, fontSize: '1.5rem', lineHeight: 1.25, color: '#0B2818' }}
      >
        Um sistema financeiro para grupos de WhatsApp, gerenciado por IA
      </Typography>

      <Typography variant="subtitle1" sx={{ color: '#3F6B52' }}>
        Cadastre participantes, registre pagamentos e organize rateios do seu grupo — tudo por texto, foto ou lista, direto pro assistente de IA.
      </Typography>
    </Box>
  )
}
